import { implementCustomExpressions } from '../__generated/implementation.js';
import { partData } from '../data/parts.js';
import { round } from '../util/round.js';
import { CabinetWidth } from './common.js';
const getPartData = (s)=>{
    const key = s.$dataKey;
    const data = partData[key];
    if (!data) {
        throw new Error(`No part data found for type: ${s.type} and key: ${key}`);
    }
    return data;
};
export const partExpressions = implementCustomExpressions({
    BottomPart: {
        $name: (s)=>getPartData(s).name,
        $sku: (s)=>getPartData(s).sku,
        $priceSku: (s)=>getPartData(s).sku,
        $description: (s)=>getPartData(s).description
    },
    EndPanel: {
        $width: (s)=>s.$netWidth,
        $netDepth: (s)=>{
            if (s.$backPanelFilter) {
                return CabinetWidth.W29_25;
            }
            return CabinetWidth.W28_25;
        },
        // End panel extends to cover the back panel, but it should
        // not increase its depth, otheriwse other cabinets would move.
        $depth: (s)=>CabinetWidth.W28_25 - s.$room.$doorThickness,
        $endPanelDepth: (s)=>s.$netDepth,
        $dataKey: (s)=>`${s.type}_${s.$netDepth}`,
        $endPanelOffsetY: (s)=>-s.$frontPanelBottomOverhang,
        $endPanelOffsetZ: (s)=>s.$room.$doorThickness,
        $endPanelHeight: (s)=>s.$frontPanelHeight,
        $hasWorkSurface: ()=>true
    },
    Filler: {
        $width: (s)=>round(s.$netWidth + s.$room.$cabinetSideGap, 4),
        $dataKey: (s)=>`${s.type}_${s.width}`,
        $offsetY: (s)=>s.$frontPanelHeight / 2 + s.$room.$toeKickHeight - s.$frontPanelBottomOverhang + 0.25 * s.$room.$inchToMm,
        $fillerHeight: (s)=>s.$frontPanelHeight,
        $hasWorkSurface: ()=>true
    },
    RearPanel: {
        $dataKey: (s)=>`${s.type}_${s.width}`,
        $width: (s)=>s.width
    }
});

//# sourceMappingURL=parts.js.map